import axios from "axios";
import axiosInstance from "./axsiosInstance";

const API_URL = process.env.REACT_APP_API_URL;
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });
  failedQueue = [];
};

const refreshToken = async (setIsAuth) => {
  try {
    // const response = await axios.post(
    //   `${API_URL}auth/refresh`,
    //   {},
    //   {
    //     withCredentials: true,
    //   }
    const response = await axiosInstance.post(`auth/refresh`, {});

    const newToken = response.data.access_token || response.data.token;

    if (newToken) {
      localStorage.setItem("accessToken", newToken);
      return newToken;
    } else {
      throw new Error("No token in response");
    }
  } catch (error) {
    console.error("Refresh token error:", error);
    localStorage.removeItem("accessToken");
    setIsAuth(false);
    throw error;
  }
};

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - MOVED OUTSIDE configureAxios
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (!error.response) {
      console.error("Network error:", error);
      return Promise.reject(error);
    }

    // 401 Unauthorized or 403 Forbidden - refresh token
    if (
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry
    ) {
      if (originalRequest.url?.includes("/auth/refresh")) {
        console.log("Refresh token expired, logging out");
        localStorage.removeItem("accessToken");
        // Redirect to login page or reload
        window.location.href = "/login";
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise((resolve, reject) => {
        refreshToken(() => {}) // Empty function since setIsAuth is not available
          .then((token) => {
            axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
            originalRequest.headers.Authorization = `Bearer ${token}`;

            processQueue(null, token);
            resolve(axiosInstance(originalRequest));
          })
          .catch((err) => {
            console.error("Token refresh failed:", err);
            processQueue(err, null);

            localStorage.removeItem("accessToken");
            // Redirect to login page or reload
            window.location.href = "/login";

            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);

// Simplified configureAxios function
export const configureAxios = (setIsAuth) => {
  // Empty function - interceptor is now configured globally
};
